/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { config, fetchGraphQl } from '@/cart/api';
import { state } from '@/cart/lib/state';

import { CREATE_GUEST_CART_MUTATION } from './graphql/CreateCartMutation';

export const createGuestCart = async () => {
  const { disableGuestCart } = config.getConfig();

  // If guest cart is disabled, throw an error
  if (disableGuestCart) {
    throw new Error('Guest cart is disabled');
  }

  // Return new empty cart id
  return await fetchGraphQl(CREATE_GUEST_CART_MUTATION).then(({ data }) => {
    const cartId = data.createGuestCart.cart.id;

    // Set cart id in state
    state.cartId = cartId;

    return cartId;
  });
};
